import React from 'react';
import { BUTTON_STYLES } from '../../constants/styles';
import { ValidationWarning } from '../Messages/StatusMessages';
import SubstitutionBadge from './SubstitutionBadge';

const StarchSubstitutionSection = ({ order, orderIndex, onStarchSubstitution, isLocked, saving, autoSubstitution }) => {
    if (!order.starchOptions || order.starchOptions.length === 0) {
        return null;
    }

    const showAutoSubBadge = autoSubstitution?.addedId &&
        order.starchOptions.some(opt => opt.id === autoSubstitution.addedId && opt.isActive);

    const getActiveStarchCount = () => {
        if (!order.starchOptions) return null
        return order.starchOptions.filter(option => option.isActive).length;
    };

    return (
        <div style={{ marginBottom: '15px' }}>
            <label style={{
                display: 'block',
                marginBottom: '8px',
                fontSize: '14px',
                fontWeight: 'bold',
                color: '#555'
            }}>
                Starch:
                {showAutoSubBadge && (
                    <SubstitutionBadge
                        removedName={autoSubstitution.removedName}
                        addedName={autoSubstitution.addedName}
                    />
                )}
            </label>
            {getActiveStarchCount() !== null && getActiveStarchCount() !== undefined && getActiveStarchCount() < 1 && (
                <ValidationWarning message="No Starch Selected" />
            )}
            <div style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '8px'
            }}>
                {order.starchOptions.map((starchOption, index) => {
                    const isActive = starchOption.isActive;
                    const isDisabled = isLocked || saving || isActive;

                    return (
                        <button
                            key={index}
                            onClick={() => {
                                if (!isActive && onStarchSubstitution) {
                                    const currentActiveStarch = order.starchOptions.find(opt => opt.isActive);
                                    const oldStarchId = currentActiveStarch ? currentActiveStarch.id : null;
                                    onStarchSubstitution(orderIndex, starchOption.id, oldStarchId);
                                }
                            }}
                            disabled={isDisabled}
                            style={BUTTON_STYLES.substitution(isActive, isDisabled)}
                        >
                            <span style={{
                                marginRight: '4px',
                                fontSize: '12px'
                            }}>
                                {isActive ? '✓' : '+'}
                            </span>
                            {starchOption.name}
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default StarchSubstitutionSection;